import {
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmationModal,
  editDetailModal,
  setEditCredential,
} from "../../../slices/agMember/agMemberSlice";
import { Button, Col, Row } from "react-bootstrap";
import DetailsConfirmationModal from "./DetailsConfirmationModal";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const EditPrimaryDetailsModal = () => {
  const dispatch = useDispatch();
  const editDetailShow = useSelector((state) => state.agMember.editDetailShow);
  const formState = useSelector((state) => state.common.formRendererState);
  const editCredential = useSelector((state) => state.agMember.editCredential);
  const mode = useSelector((state) => state.agMember.mode);

  const confirmationShow = useSelector(
    (state) => state.agMember.confirmationShow
  );

  const handleClose = () => {
    dispatch(editDetailModal(false));
    dispatch(setEditCredential({}));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const sanitizedValue = value.replace(/[^0-9]/g, "");
      if (sanitizedValue.length <= 10) {
        dispatch(
          setEditCredential({
            ...editCredential,
            [name]: sanitizedValue,
          })
        );
      }
    } 
    else if(name === "password") {
          dispatch(
               setEditCredential({
                   ...editCredential,
                   [name]: value
               })
          )
    }
    else {
      dispatch(
        setEditCredential({
          ...editCredential,
          [name]: value,
        })
      );
    }


  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(editDetailModal(false));
    dispatch(confirmationModal(true));
  };

  const isFormChanged = editCredential.mobileNumber || editCredential.emailId || editCredential.password;

  return (
    <div>
      <Modal
        isOpen={editDetailShow}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        className="border-0"
        modalClassName="modal fade zoomIn"
        toggle={handleClose}
        size="lg"
      >
        <Form className="tablelist-form" onSubmit={updateClickHandler}>
          <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
            Edit Credentials
          </ModalHeader>
          <ModalBody className="modal-body">
            <Row className="g-3">
              <Col lg={12}>
                <FormGroup>
                  <Label for="mobileNumber">Mobile Number</Label>
                  <Input
                    type="text"
                    id="mobileNumber"
                    name="mobileNumber"
                    value={editCredential.mobileNumber}
                    onChange={handleChange}
                    placeholder="Enter mobile number"
                    maxLength={10}
                    pattern="^\d{10}$"
                    // required
                    // pattern="/[^0-9-]/g, ''"
                    onkeyup="this.value = this.value.replace(/[^0-9-]/g, '');"
                    title="Please enter a valid 10-digit mobile number"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="emailId">Email ID</Label>
                  <Input
                    type="email"
                    id="emailId"
                    name="emailId"
                    value={editCredential.emailId}
                    onChange={handleChange}
                    placeholder="Enter email ID"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" // This pattern validates common email formats
                    title="Please enter a valid email address"
                    // required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="emailId">Password</Label>
                  <Input
                    type="password"
                    id="password"
                    name="password"
                    value={editCredential.password}
                    onChange={handleChange}
                    maxLength={8}
                    placeholder="Enter your password"
                    pattern="^^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#]).{8,}$" // This pattern validates common email formats
                    title="Password must have at least 8 chars with uppercase, lowercase, number and special char"
                    // required
                  />
                </FormGroup>
              </Col>
               <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    type="submit"
                    className="primary primary_button"
                    disabled={!isFormChanged}
                  >
                    Confirm & Save
                  </Button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Form>
      </Modal>
      <DetailsConfirmationModal />
    </div>
  );
};

export default EditPrimaryDetailsModal;
